import type { documents as en } from '@/i18n/locales/en/documents';
import type { Translation } from '@/i18n/types';

export const documents: Translation<typeof en> = {
  page: {
    title: 'Documentos',
    lead: 'Carregue e gira documentos para {{company}}.',
    noScope: 'Selecione uma empresa para ver os seus documentos.',
    forbidden: 'Não tem permissão para ver os documentos desta empresa.',
  },
  upload: {
    title: 'Carregar documento',
    titleField: 'Título',
    category: 'Categoria',
    audience: 'Público-alvo',
    fileUrl: 'URL do ficheiro',
    file: 'Ficheiro',
    upload_status: {
      uploading: 'A carregar…',
      tooLarge: 'O ficheiro é demasiado grande (máx. 10MB).',
      invalidType: 'Tipo de ficheiro não permitido.',
    },
    fileUrlHint: 'É carregado de imediato; ou preencha um URL existente abaixo.',
    requiresReadConfirmation: 'Requer confirmação de leitura',
    requiresReadConfirmationHint: 'Os membros têm de confirmar que leram este documento.',
    submit: 'Carregar',
  },
  categories: {
    algemeen: 'Geral',
    beleid: 'Política',
    veiligheid: 'Segurança',
    hr: 'RH',
    vitaliteit: 'Vitalidade',
  },
  audiences: {
    iedereen: 'Todos',
    management: 'Direção',
    per_afdeling: 'Por departamento',
    per_locatie: 'Por localização',
  },
  status: {
    gepubliceerd: 'Publicado',
    archief: 'Arquivado',
  },
  library: {
    title: 'Biblioteca de documentos',
    empty: 'Ainda sem documentos.',
    totalViews: 'Total de visualizações: {{count}}',
    columns: {
      title: 'Título',
      category: 'Categoria',
      views: 'Visualizações',
      status: 'Estado',
    },
  },
  actions: {
    new: 'Carregar documento',
    cancel: 'Cancelar',
    publish: 'Publicar',
    archive: 'Arquivar',
  },
};
